<template>
  <v-app id="app">
    <router-view />
  </v-app>
</template>
<script>
export default {
  name: 'App'
};
</script>
<style lang="scss">
.blue-background {
  background-color: #e1e8f8;
}

.required label::after {
  content: ' *';
}

.required--radio legend::after {
  content: ' *';
}
</style>
